import { render } from "./SendSearch.vue?vue&type=template&id=a4081f7c&scoped=true&ts=true"
import script from "./SendSearch.vue?vue&type=script&lang=ts"
export * from "./SendSearch.vue?vue&type=script&lang=ts"

import "./SendSearch.vue?vue&type=style&index=0&id=a4081f7c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4081f7c"]])

export default __exports__